export const useApiDelete = async <TResponse = unknown>(
  url: string
): Promise<{ data: TResponse | null; error: unknown | null }> => {
  try {
    const data = await useNuxtApp().$api<TResponse>(url, {
      method: 'DELETE'
    })

    return { data, error: null }
  } catch (error: unknown) {
    if (error instanceof Error && 'response' in error) {
      return { data: null, error: (error as { response: unknown }).response }
    }
    return { data: null, error }
  }
}
